import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ReportsActions";
import { CustomersByYears } from "../generated";
import { InSessionStorage } from "../common/InLocalStorage";
import LoginActions from "../login/LoginActions";

class CustomersByYearsStore extends AbstractGetAllStore<CustomersByYears>{
    constructor() {
        super(x => x.year.toString(), new InSessionStorage<CustomersByYears>("CustomersByYears"));
        Dispatcher
            .onfunction(Actions.getCustomersByYear, result => this.setAll(result))
            .onfunction(LoginActions.signOut, result => this.clear())
            ;
    }

    public useAll = () => this.useAllWithAction(() => Actions.getCustomersByYear());
}

export default new CustomersByYearsStore()
